'use client';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { Hero } from './section/1-hero';
import { KeyMetrics } from './section/2-key-metrics';
import { Performance } from './section/3-performance';
import { Advantages } from './section/4-advantages';
import { InfoTabs } from './section/5-info-tabs';
import { SubscriptionFooter } from './section/6-subscription-footer';

export const DetailsPageLayout = () => {
  return (
    <main
      className={css({
        maxW: 'desktopMaxWidth',
        mx: { base: 16, smallDesktop: 'auto' },
        tabletDown: { pb: 160 },
        tablet: { pb: 130 },
      })}
    >
      <div
        className={css({
          display: 'flex',
          tabletDown: { flexDirection: 'column', pt: 8, gap: 24 },
          tablet: { flexDirection: 'row', pt: 64, gap: 32 },
        })}
      >
        <div className={stack({ tabletDown: { gap: 32, w: '100%' }, tablet: { gap: 64, w: 757 } })}>
          <Hero />
          <div className={css({ tablet: { display: 'none' } })}>
            <KeyMetrics />
          </div>
          <Performance />
          <Advantages />
          <InfoTabs />
        </div>
        <aside
          className={css({
            tabletDown: { display: 'none' },
            tablet: {
              display: 'block',
              flex: 1,
              flexShrink: 0,
              position: 'sticky',
              top: 'calc({sizes.navigationHeight} + 16px)',
              alignSelf: 'flex-start',
            },
          })}
        >
          <KeyMetrics />
        </aside>
      </div>
      <div
        className={css({
          tablet: { display: 'none' },
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          bg: 'background.default.level-0',
          p: 16,
        })}
      >
        <SubscriptionFooter />
      </div>
    </main>
  );
};
